import { render, staticRenderFns } from "./PreviewQType1.vue?vue&type=template&id=9cfc7f7e&scoped=true&"
import script from "./PreviewQType1.vue?vue&type=script&lang=js&"
export * from "./PreviewQType1.vue?vue&type=script&lang=js&"
import style0 from "./PreviewQType1.vue?vue&type=style&index=0&id=9cfc7f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfc7f7e",
  null
  
)

export default component.exports